import Vue from 'vue'

let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  top1: '概览',
  top2: '技术规格',
  // dec: '高度360°全景云台，便携耐用，操作简单',
  yushou: '【新品预售】',
  price: 'RMB 899',
  buy: '立即购买',
  cart: '加入购物车',
  tiaokuan: '* 付款成功后5个工作日内发货，默认顺丰快递包邮',
  guige: {
    name: '技术规格',
    dec: [
      '*由于受环境光、显示器色差、闪光等拍摄的影响，产品颜色上可能存在一定的彩色偏差，请见谅。'
    ],
    arr: [
      {
        name: '产品型号',
        val: ['ET1004三脚架+Y-10云台']
      },
      {
        name: '产品名称',
        val: ['Y-10系列铝合金可反折扣式套餐']
      },
      {
        name: '产品重量',
        val: ['含云台1.59KG(云台重量0.37KG)']
      },
      {
        name: '云台类型',
        val: [
          'Y-10专业球形云台'
        ]
      },
      {
        name: '脚架材质',
        val: [
          '铝合金脚管+铝合金锻造主体'
        ]
      },
      {
        name: '脚管管径',
        val: [
          '粗25mm、细16mm'
        ]
      },
      {
        name: '脚管节数',
        val: [
          '4节'
        ]
      },
      {
        name: '安全负重',
        val: [
          '8KG'
        ]
      },
      {
        name: '收纳高度',
        val: [
          '56cm'
        ]
      },
      {
        name: '低角度',
        val: [
          '21.5cm'
        ]
      },
      {
        name: '展开高度',
        val: [
          '不升中轴高123.5cm、升中高147cm、升中轴+短中轴高度156.5cm（含云台、云台高度8.8cm）'
        ]
      },
      {
        name: '原厂标配',
        val: [
          '包装盒、脚架包、脚架套装、短中轴、脚架包背带、4只六角扳手、合格证、说明书'
        ]
      }
    ]
  },
  lunguige: {
    name: '技术规格',
    dec: '注：本页面所列配置及参数均以实际上市产品为准，如有变更，恕不另行通知',
    arr: [
      {
        name: '品牌型号',
        val: ['B900脚轮']
      },
      {
        name: '脚管最小长度',
        val: ['30cm']
      },
      {
        name: '脚管最大长度',
        val: ['43cm']
      },
      {
        name: '脚管最短距离',
        val: [
          '56cm'
        ]
      },
      {
        name: '脚管最长距离',
        val: [
          '78cm'
        ]
      },
      {
        name: '收纳长度',
        val: [
          '43cm'
        ]
      },
      {
        name: '材 料',
        val: [
          '6063T5铝合金ABS'
        ]
      },
      {
        name: '颜 色',
        val: [
          '黑色'
        ]
      },
      {
        name: '承担能力',
        val: [
          '15kg'
        ]
      },
      {
        name: '脚管节数',
        val: [
          '2节'
        ]
      },
      {
        name: '自 重',
        val: [
          '1.7kg'
        ]
      },
      {
        name: '解锁类型',
        val: [
          '板扣式'
        ]
      },
      {
        name: '滑轮直径',
        val: [
          '5cm'
        ]
      },
      {
        name: '配 置',
        val: [
          '脚轮、便携包'
        ]
      }
    ]
  },
  color: {
    key: '颜色',
    val: '标准色'
  },
  service: {
    type: '',
    key: '配件',
    val: [
      '三脚架型号：ET1004三脚架',
      '云台型号：Y-10云台',
      '脚轮型号：B900脚轮'
    ],
    peijian: '了解详细参数'
  },
  count: {
    key: '数量'
  },
  zhijia: {
    name: '专业拍摄脚架',
    sub: '采用铝合金材质锻造，兼顾轻便性与可靠性',
    detail: '专业便携脚架细节',
    detailArr: [
      {
        name: '专业球形云台',
        img: `${baseUrl}images/zhijia-detail01.png`
      },
      {
        name: '脚管三段角度调节按钮',
        img: `${baseUrl}images/zhijia-detail02.png`
      },
      {
        name: '安全的中轴升降锁紧按钮',
        img: `${baseUrl}images/zhijia-detail03.png`
      },
      {
        name: '防滑保暖致密海绵护手',
        img: `${baseUrl}images/zhijia-detail04.png`
      },
      {
        name: '可伸缩中轴挂钩稳定脚架',
        img: `${baseUrl}images/zhijia-detail05.png`
      },
      {
        name: '方便快捷的版扣脚管',
        img: `${baseUrl}images/zhijia-detail06.png`
      }
    ]
  },
  hualun: {
    name: '专业脚架滑轮',
    sub: '稳固可靠 操作顺畅'
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/purchasezhijia.js